export default {
  title: "Publication in the Catalogue",
  untilDeadline: "Not later than {date}",
  startDate: "Application submission since {date}",
  deadlineInfo:
    "Please note that if information is not submitted to the catalogue by {date}, only the company name, country and stand number will be published in all official publications of the exhibition (catalogue, guide and online catalogue-guide).",
  unavailable: "Placement on Personal Account is unavailable",
  deadlinePassed: "Placement period on Personal Account ended",

  confirmClose:
    "The application to the catalog is not submitted. Are you sure you want to close the catalog application?",

  betweenEndOrderAndPrintStart: "You can submit your application within 1 day",

  orderSent: "Sent",
  orderNotSent: "Not sent",
  orderModeration: "Accepted for moderation",
  orderAccepted: "Accepted for publication in the catalogue",

  sendBtn: "Fill in",
  sendAgree: "By submitting an application, you agree to the",
  termsPart1: "General terms",
  termsPart12: "General terms",
  termsPart2:
    "of publication of advertising and information materials in the Official Exhibition Catalogue.",

  colorgNotification: "Placement in the catalogue of the collective organiser",

  hasCatalogOrder1cMessage:
    "The information was added by the expert responsible for the catalog",

  modal: {
    spellerButton: "Check spelling",
    spellerNote1: "Spell check: ",
    spellerNote2: "Yandex.Speller",
    infoTogglerTitle:
      "Information about publication in different sources of information",
    managerTitle: "Any questions? Contact your manager.",
    errorPriceServices:
      "N/A - no fees have been determined for some services. Please contact your manager.",
    errorPriceService:
      "There is no set fee for the selected service. Please contact your manager.",

    nav: {
      alphabetList: "Alphabetical List of Exhibitors",
      rubrics: "List of Products and Services",
      rubricsPackages: "Package publications", // for preview
      russianExporter: "Russian exporter",
      packagePlacement: "Package Services",
      packagePlacementLogo: "Logotype", // for preview
      adService: "Advertisement",
      preview: "Application Preview",
      backBtn: "Back"
    },

    alphabetList: {
      basicInfoHelp: "Basic information on your company is taken from",
      basicInfoLink: "company profile",
      basicInfo: "Basic information",
      requiredFields: "Required Information",

      companyNameForBooklet: "Official company name and/or trademark",
      companyCountryForBooklet: "Country of company for the List of Countries",

      additionalFields: "Example of the standard information in the catalogue",

      companyNameEng: "Company name and/or trademark in English",
      companyNameEngValid:
        "There are invalid characters in the field «Company name and/or trademark in English». The field must not contain any Russian letters.",
      companyOwnerType: "Legal form of the company",
      companyCountry: "Country",
      companyRussianExporter: "Russian exporter",
      stands: "Stands",
      companyStand: "Stand number",
      invalidCompanyStand: "Incorrect stand number",
      extraCompanyStand: "Additional stand number",
      companyAddress: "Company address",
      extraCompanyAddressForRubric: "Additional address for section",
      extraCompanyAddress: "Additional company address",
      companyWebsite: "Web-site",
      companyEmail: "E-mail",
      companyPhone: "Telephone",
      companyFax: "Fax",
      totalSymbolsAmount: "Total number of characters:",
      freeSymbols: "Free:",
      extraSymbols: "Extra:",
      companyInfoTitle: "Brief information on your company activity",
      companyInfo:
        "Brief information on your company activity in Russian (translation)",
      companyInfoResident:
        "Brief information on your company activity in Russian",
      companyInfoEng: "Brief information on your company activity in English ",
      companyInfoEngResident:
        "Brief information on your company activity in English (translation)",
      companyInfoPlaceholder:
        "{freeAmount} characters, are included in the participation cost, extra {stringLength} symbols — {price} {currencySymbol}",
      companyInfoEngPlaceholder: "Translation",
      companyInfoCounting:
        "The cost is calculated from the field «Brief information on your company activity in English».",
      companyInfoCountingIsResident:
        "The cost is calculated from the field «Brief information on your company activity in Russian».",
      exporter:
        "Contribute to the section ”Russian exporter / interested in exporting”",
      importSubstitution: "Contribute to the section «Import Substitution»",
      contractManufacturing: "Contract manufacturing",

      additionalSymbols: "Extra {amount} symbols",
      letterNote:
        "the company name will be alphabetized in the catalogue according to the first letter of the name",

      addExtraAddress: "Add one more address",
      addExtraCompanyStand: "Add one more stand",

      errors: {
        companyInfoRus:
          "Brief information on your company activity must be filled in Russian",
        companyInfoEng:
          "Brief information on your company activity must be filled in English"
      }
    },

    rubricator: {
      rubricsTitle: "Headings",
      rubricsFreeNote:
        "the cost of participation includes brief information in",
      rubricsFreeNotePluralize: ["heading", "headings"],

      chosenNote: "Heading number:",

      chooseRubricsBtn: "Choose headings",
      addRubricBtn: "Add a heading",

      forAllTitle: "For all chosen headings",
      packagePlacement: "Package placement",
      packagePlacementPrimary: "applied automatically",

      footerLastStepPleaseSelect: "To continue, select at least one category",
      footerPaidServices: "Paid services",

      countPaidRubrics: [
        "chargeable section",
        "chargeable sections",
        "chargeable sections"
      ],

      countRubrics: ["section", "sections", "sections"],
      countSelectedPakage1: "Selected {count} package of {price}",
      countSelectedPakage3_4: "Selected {count} packages of {price}",
      countSelectedPakage5_20: "Selected {count} packages of {price}"
    },

    russianExporterList: {
      title: "Special section «Russian exporter»",
      subtitle: "(Included in the participation fee)",
      primary:
        "The form is only to be completed by Russian companies supplying goods to foreign markets.",

      searchPlaceholder: "Find the heading",

      footerAllRubrics: "Total for headings:",
      footerPaidRubrics: "Charged headings:",
      footerSelectBtn: "Choose",

      printRubrics: "Print out"
    },

    rubricsSelect: {
      title: "Choice of the headings",

      freeNote: "The cost of participation includes brief information in",
      freeNotePluralize: ["heading", "headings"],

      suggestBtn: "Suggest new heading",
      suggestFormText:
        "If you did not find the heading you need, write the name of the heading you need below and in the near future we will add it to the catalogue, or contact the catalogue department by calling 8 800 707 37 99",
      suggestFormPlaceholder: "Name",

      suggestionSuccess: "Suggestion accepted.",

      searchPlaceholder: "Find the heading",

      printRubrics: "Print out",

      footerAllRubricsSelected: "Total for headings:",
      footerPaidRubricsSelected: "Charged headings:",
      footerSelectBtn: "Choose"
    },

    logo: {
      title: "Company logo (for paid services)",
      description:
        "Acceptable formats: Adobe Illustrator CS4, and BMP, TIFF (full size with resolution not\n" +
        "fewer than 300 pixels per inch).",

      loadBtn: "Upload",
      destroyBtn: "Remove",
      changeBtn: "Change",
      loadingBtn: "Uploading {filename}",

      orderLogoImageAlt: "Uploaded company logo for the exhibition",
      companyLogoImageAlt:
        "Company logo for the exhibition from the company profile",
      noLogoImageAlt: "No loaded logo for the exhibition",

      errors: {
        base64Encoding: "Image Encoding Error",
        fileTooBig: "You uploaded too large file",
        incorrectFileFormat: "Invalid file format",
        cantSaveFile: "Failed to save logo",
        cantSaveInfo: "Could not update logo information\n"
      }
    },
    cover: {
      title: "Cover image (for paid services)",
      description: "In JPG, JPEG, PNG formats: 1920x720 px.",
      presentationFileTitle: "Link to the presentation (for paid services)",
      videoLinkTitle:
        "Link to the video (Rutube, VK video) (for paid services)",
      presentationFileDescription: "In PDF format",
      videoLinkPlaceholder: "Provide the link to the video (rutube, vk video)"
    },
    packageServices: {
      logoPlacementTitle: "Logos and Advertising modules",
      majorServicesTitle: "Package services",
      additionalServicesTitle: "Extra services"
    },

    adServices: {
      adInCatalogTitle: "Advertisement services in the Catalogue",
      adInGuideTitle: "Advertisement services in the Guide",
      adInOtherTitle: "Other advertising services",

      noAdServicesMessage: "There are no advertising services.",

      additionalApprovalNote:
        "Advertising on the covers and footers of the catalogue and guide is required to have an additional coordination with the Catalogue Department.",

      graphicFiles: "Graphics files (for paid services)",
      graphicFilesFormats:
        "In JPG, JPEG, PNG formats or archive with ZIP format.",
      graphicFilesPrimary:
        "You can give a link to a file sharing site with additional graphics files"
    },

    footer: {
      total: "Total:",
      totalVAT: "Cost of services incl. VAT:",
      nextBtn: "Continue",
      backBtn: "Back",
      sendBtn: "Submit",
      closeBtn: "Close",

      submitAgreeMessage: "Are you sure you want to submit the application?",
      submitSuccessMessage: "Your application has successfully been sent!"
    },

    preview: {
      changeBtn: "Change",
      companyLetter: "Company under the letter in the list",
      standNumber: "Stand number",

      additionalSymbols: "Extra {amount} symbols in company details:",
      additionalEngSymbols:
        "Extra {amount} symbols in company details in English:",
      additionalAddresses: "Extra company addresses:",
      additionalRubricAddresses: "Extra addresses:",

      majorPackagePrice: "Total:",
      additionalPackagePrice: "Total:",
      servicesPrice: "Total:",
      rubricPrice: "Total:",
      adServicePrice: "Total:",

      adServiceCatalog: "Advertising services in the catalogue",
      adServiceGuide: "Advertising services in the guidebook",
      adServiceOther: "Other advertising services",

      downloadOrder: "Download out the application",

      notServicesWithLogo: "No logo service selected (no logo will be placed)",
      notServiceAdditional:
        "No service with an advertising module is selected (files will not be published)",
      notServicesWithCoverFiles:
        "The ad module service is selected, but no files have been uploaded",
      notLogoForServices: "Logo services selected but no logo is uploaded",
      notLinkGraphicFiles:
        "Advertising services selected but no graphics files indicated",

      documents: {
        requiredField: "Required",
        infoOrder:
          "When ordering paid services, attach application form with stamp and signature in PDF format (no more than 5Mb)",
        infoRequisites: "Attach payer details in DOCX format",
        upload: "Download",
        downloadFile: "Download file",
        errorSize:
          "File is too large ({filesize}Mb). Maximum file size: {maxFilesize}Mb.",
        errorAccepted:
          "File upload error: allowable file formats are {acceptedFiles}"
      }
    }
  }
};
